exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!slick-carousel/slick/slick.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js!slick-carousel/slick/slick-theme.css"), "");

// module
exports.push([module.id, "#root {\n  background: black; }\n\ndiv#preload {\n  display: none; }\n\n.divider-title {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n  .divider-title::before, .divider-title::after {\n    height: 2px;\n    display: inline-block;\n    content: \"\";\n    background: white;\n    width: 30%;\n    margin: 0; }\n  .divider-title > div {\n    display: inline-block; }\n\n.ui.inverted.grey.header > .content {\n  color: white !important; }\n\n.sub.header {\n  color: white !important; }\n\n.sgr-admin {\n  background: #ededed; }\n  .sgr-admin #root {\n    background: #ededed !important; }\n\nbody {\n  background: #ededed !important; }\n\n.rdw-editor-main {\n  background: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainAdminWYSIWYG/MainAdminWYSIWYG.scss
// module id = 1254
// module chunks = 0